import React from 'react';
import { Button } from './ui/button';
import { Loader2, Sparkles } from 'lucide-react';

const PACKS = [
  {
    id: 'credits_20',
    testId: 'credits-pack-20',
    title: '+20 consultas',
    price: 'R$ 29,00',
    perUnit: 'R$ 1,45 por consulta',
    highlighted: false,
  },
  {
    id: 'credits_50',
    testId: 'credits-pack-50',
    title: '+50 consultas',
    price: 'R$ 59,00',
    perUnit: 'R$ 1,18 por consulta',
    highlighted: false,
  },
  {
    id: 'credits_100',
    testId: 'credits-pack-100',
    title: '+100 consultas',
    price: 'R$ 99,00',
    perUnit: 'R$ 0,99 por consulta',
    highlighted: true,
    badge: 'Melhor custo · Reserva Clínica',
  },
];

export const CreditPackCards = ({ onBuy, loadingPack }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-2">
    {PACKS.map((pack) => (
      <div
        key={pack.id}
        className={
          pack.highlighted
            ? 'relative rounded-xl border-2 border-teal-500 p-5 bg-teal-50 dark:bg-teal-900/20 flex flex-col'
            : 'relative rounded-xl border border-slate-200 dark:border-slate-700 p-5 bg-white dark:bg-slate-900 flex flex-col'
        }
        data-testid={pack.testId}
      >
        {pack.badge && (
          <span className="absolute -top-3 left-4 bg-teal-500 text-white text-[10px] font-semibold uppercase tracking-wider px-2 py-1 rounded-full flex items-center gap-1">
            <Sparkles className="h-3 w-3" /> {pack.badge}
          </span>
        )}
        <div className="text-xl font-semibold mb-1">{pack.title}</div>
        <div className={`text-2xl font-bold mb-1 ${pack.highlighted ? 'text-teal-600 dark:text-teal-400' : 'text-primary'}`}>
          {pack.price}
        </div>
        <div className="text-xs text-slate-500 dark:text-slate-400 mb-1">pagamento único</div>
        <div className="text-xs text-slate-500 dark:text-slate-400 mb-4">{pack.perUnit}</div>
        <Button
          type="button"
          className={pack.highlighted ? 'w-full mt-auto bg-teal-600 hover:bg-teal-700 text-white' : 'w-full mt-auto'}
          variant={pack.highlighted ? 'default' : 'outline'}
          disabled={loadingPack !== null}
          onClick={() => onBuy(pack.id)}
          data-testid={`${pack.testId}-buy`}
        >
          {loadingPack === pack.id ? (
            <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Redirecionando...</>
          ) : 'Comprar'}
        </Button>
      </div>
    ))}
  </div>
);
